import React, {useEffect, useState} from "react";
import {
  Box,
  Button, Checkbox,
  CircularProgress,
  Dialog,
  DialogContent, FormControlLabel,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import {useParams} from "react-router-dom";
import {firebase} from "../firebase/clientApp";
import {Edit} from "@mui/icons-material";
import axios from "axios";
import {API_URL, THEME_CONFIG} from "../config";
import {CustomAlert} from "./shared/CustomAlert";

export const DisplayName = ({userData, setUserData}) => {
  const {primary, } = THEME_CONFIG

  const {eventOwnerId, id} = useParams()
  const [state, setState] = useState({displayName: '', teamName: ''})
  const [error, setError] = useState(false)
  const [setting, setSetting] = useState(false)
  const [editing, setEditing] = useState(false)

  const [privacy, setPrivacy] = useState(false)

  useEffect(() => {
    if (userData) {
      setState(userData)
    }
  }, [userData])

  const handleSetDisplayName = (event) => {
    setState({...state, displayName: event.target.value})
  }

  const handleSetTeam = (event) => {
    setState({...state, teamName: event.target.value})
  }

  const submitDisplayName = async (event) => {
    event.preventDefault()
    setSetting(true)
    let uid = firebase.auth().currentUser.uid
    await axios.post(`${API_URL}users/${eventOwnerId}/events/${id}/users`, {
      user: uid,
      displayName: state.displayName,
      teamName: state?.teamName ?? ""
    })
      .then(res => {
        setUserData({displayName: state.displayName ?? '', teamName: state.teamName ?? ''})
        setError("")
        setEditing(false)
      })
      .catch((err) => {
        console.log("NickName già preso!!!", err?.response?.data?.message ?? "There was an error")
        setError(err?.response?.data?.message ?? "There was an error")
      })
      .finally(() => {
        setSetting(false)
      })
  }

  return (
    <Box px={3} my={2}>
      {
        (userData.displayName === '' || !userData.displayName) ?
          <Box>
            <Box sx={{
              background: 'rgba(0,0,0,0.65)',
              width: '100%',
              height: '100vh',
              position: 'fixed',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: -1
            }}/>
            <Typography gutterBottom textAlign={'center'} fontSize={20}>
              Enter your name and surname
            </Typography>
            <form onSubmit={submitDisplayName}>
              <TextField
                fullWidth
                required
                inputProps={{style: {fontSize: '1.2rem'}}}
                placeholder="Name and surname"
                id="displayName"
                value={state.displayName}
                onChange={handleSetDisplayName}/>

              {!editing &&
                <Stack alignItems={'start'} py={3}>
                  <Typography variant="body2" fontWeight={'light'} color="textSecondary" textAlign={'left'}>
                    To continue, you need to read and accept the privacy policy. Your nickname will only be used to
                    identify you within the platform.
                    <br/>For more details, please read our <i><a href={"/Privacy policy for ICA 2025.pdf"} style={{fontWeight: 'bold', color: primary}}>Privacy Policy</a></i>.
                  </Typography>
                  <Stack ml={'-12px'} direction={'row'} alignItems={'center'} justifyContent={'center'}>
                    <Checkbox
                      required
                      name="presoVisioneInformativa"
                      onChange={(e) => setPrivacy(e.target.checked)}
                    />
                    <Typography variant="body2" fontWeight={'light'} color="textSecondary" textAlign={'left'}>
                      I have read and accept the privacy policy
                    </Typography>
                  </Stack>
                </Stack>}

              <Box display={'flex'} justifyContent={'center'}>
                {editing && <Button sx={{color: 'white'}} onClick={() => setEditing(false)}>
                  Annulla
                </Button>}
                {setting ? <CircularProgress/> :
                  <Button variant={'default'} type={'submit'}
                          disabled={
                            (editing && userData.displayName === state.displayName) || (!state.displayName || !privacy)
                          }>
                    ENTER
                  </Button>}
                <CustomAlert open={!!error} message={error} setOpen={setError} severity={'error'}/>
              </Box>
            </form>
          </Box>
          :
          <>
            <Stack>
              <Stack>
                <Typography textAlign={'center'} fontSize={18} sx={{mb: 0}}>
                  Hello <b>{userData.displayName.toUpperCase()}</b>
                </Typography>
                {userData?.teamName ? <Typography gutterBottom textAlign={'center'} fontSize={20} sx={{pb: 1}}>
                  {userData.teamName ? `TEAM: #${userData.teamName}` : ''}
                </Typography> : null}
              </Stack>
              <Stack mt={'-10px'} direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Typography variant={'body2'}><i>Edit your nickname</i></Typography>
                <IconButton size={'small'} color={'primary'} onClick={() => setEditing(!editing)}>
                  <Edit fontSize={'small'}/>
                </IconButton>
              </Stack>
            </Stack>
            {editing &&
              <Dialog open={editing} fullWidth maxWidth={'md'} onClose={() => setEditing(false)}>
                <DialogContent sx={{height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <form onSubmit={submitDisplayName}>
                    <TextField
                      fullWidth
                      required
                      inputProps={{style: {fontSize: '1.2rem'}}}
                      placeholder="Nome e cognome"
                      id="displayName"
                      value={state.displayName}
                      onChange={handleSetDisplayName}
                    />
                    <Box pt={2} display={'flex'} justifyContent={'space-evenly'}>
                      {editing && <Button sx={{color: 'white'}} onClick={() => setEditing(false)}>
                        Annulla
                      </Button>}
                      {setting ? <CircularProgress/> :
                        <Button variant={'contained'} type={'submit'}
                                disabled={
                                  (editing && userData.displayName === state.displayName) || (!state.displayName)
                                }>
                          invia
                        </Button>}
                      <CustomAlert open={!!error} message={error} setOpen={setError}
                                   severity={'error'}/>
                    </Box>
                  </form>
                </DialogContent>
              </Dialog>
            }
          </>
      }

    </Box>
  )
}
